import { ApiClient } from 'services/ApiService'

export const getDataHomeScreen = () => ApiClient.get('/home/web')
export const requestBattery = (payload: any) =>
  ApiClient.post('/customer/relief/reliefs-battery', payload)
export const requestChangeOli = (payload: any) =>
  ApiClient.post('/customer/relief/reliefs-change-oil', payload)
